export default "__VITE_ASSET__DMJiZevm__"